import { IUser } from '@fg-types/user.type';

export enum SurveyType {
  ConventionRating = 'convention_rating',
  Registration = 'registration'
}
export interface Survey {
  id?: string;
  name?: string;
  description?: string;
  modelId?: string;
  modelName?: string;
  isCompleted?: boolean;
  isVisible?: boolean;
  commentsEnabled?: boolean;
  type?: SurveyType;
  questions?: SurveyQuestion[];
  newRatingCriteria?: string;
  owner?: IUser;
  questionStatus?: 'draft' | 'publish';
  isDrafted?: boolean;
}

export const SurveyQuestionResponseTypes = {
  boolean: 'True / False',
  upvote: 'Upvote / Downvote',
  string: 'Short text',
  number: 'Number',
  email: 'Email',
  phone: 'Phone Number',
  dropdown: 'Dropdown – Single Choice',
  multiselect: 'Dropdown – Multiple Choice'
};

export type SurveyQuestionResponseType = keyof typeof SurveyQuestionResponseTypes;

export interface SurveyQuestion {
  id?: string;
  name?: string;
  responseType: SurveyQuestionResponseType;
  options?: string[];
  isRequired?: boolean;
  commentsEnabled?: boolean;
  isVisible?: boolean;
  canDelete?: boolean;
  isEditable?: boolean;
  response?: Response;
  order?: number;
}

export interface SurveyResponseData {
  averageAnswer: number;
  comments: string[];
  name: string;
  questionResponses: SurveyResponseQuestionDetail[];
  surveyId: string;
}

export interface SurveyResponse {
  comment: string;
  id: string;
  owner?: IUser;
  surveyId: string;
  surveyOwnerResponse?: string;
  responses: SurveyResponseDetail[];
}

export interface SurveyResponseDetail {
  answer: 1 | -1;
  comment?: string;
  questionId: string;
  questionName?: string;
}

export interface SurveyResponseQuestionDetail {
  averageAnswer?: number;
  comments?: string[];
  downvoteCount?: number;
  name?: string;
  questionId: string;
  responseCount?: number;
  upvoteCount?: number;
}
